var classes = {"loginMenu":"pSbfH","loginMenuContent":"-f9Ib","loginMenuContentList":"g0mn1","loginMenuContentListLastItem":"MJn-B","loginMenuMobileClose":"Ya58B","loginMenuMobileBackText":"Wzpj3","loginMenuMobileCloseIcon":"lOY-R","loginMenuGridGap":"TGjAi"};

export { classes as default };
